import React, { FormEvent } from "react";

import classNames from "classnames";
import { Tooltip } from "react-tooltip";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { Checkmark } from "~/components/common/Icons/Checkmark";
import { TrashIcon, VideoDragHandle } from "~/components/common/Icons/VideoPreviewIcons";
import * as productStyles from "~/components/videoProductPage/Product.css";

import * as styles from "./WhatYouWillLearn.css";

export function SortableSkillsItem(props: {
  id: string;
  itemIndex: number;
  skillsText: string;
  isInEditMode: boolean;
  iconColor: string;
  handleSkillEdit: (event: FormEvent<HTMLDivElement>, itemId: string) => void;
  handleSkillChange: (event: FormEvent<HTMLDivElement>, itemId: string) => void;
  handleDeleteSkill: (itemId: string) => void;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.id,
    disabled: !props.isInEditMode,
  });
  if (transform) {
    transform.scaleY = 1;
  }
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className={classNames(styles.whatYouLearnSingleItemBlock, isDragging && styles.dragging)}
      key={props.id}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      {props.isInEditMode && (
        <div className={styles.draghandle}>
          <div
            role="button"
            className={`cursor-pointe skill_${props.itemIndex}_tooltip`}
            data-tooltip-content="Drag to move"
          >
            <VideoDragHandle />
          </div>
        </div>
      )}
      <div className={styles.whatYouLearnSingleItemBlockLogo}>
        <Checkmark fill={props.iconColor} />
      </div>
      <div className={styles.whatYouLearnSingleItemBlockText}>
        <div
          className={classNames(props.isInEditMode && productStyles.editableElement)}
          contentEditable={props.isInEditMode}
          onInput={(e) => props.handleSkillEdit(e, props.id)}
          onBlur={(e) => props.handleSkillChange(e, props.id)}
          suppressContentEditableWarning={true}
        >
          {props.skillsText}
        </div>
      </div>
      {props.isInEditMode && (
        <div className={styles.extraButtonsContainer}>
          <div
            role="button"
            className={classNames(styles.deleteIcon, `skill_${props.itemIndex}_tooltip`)}
            data-tooltip-content="Delete Item"
            onClick={() => {
              props.handleDeleteSkill(props.id);
            }}
          >
            <TrashIcon />
          </div>
          <Tooltip place="top" anchorSelect={`.skill_${props.itemIndex}_tooltip`} />
        </div>
      )}
    </div>
  );
}
